import { computed, readonly, ref } from 'vue'
import type { Message } from './frames'

export const createServerEventStore = () => {
    const tasks = ref<Message[]>([])
    const firstTask = ref<unknown>()

    const append = (task: Message) => {
        tasks.value.push(task)
    }

    const setFirstTask = (raw: unknown) => {
        firstTask.value = raw
    }

    const tasksByTaskId = (taskId: string) => tasks.value.filter(task => task.taskId === taskId)

    const dropTasks = (taskId: string, keepAfter: number) => {
        let skipped = 0
        tasks.value = tasks.value.filter(task => {
            if (task.taskId !== taskId) return true
            skipped++
            return skipped > keepAfter
        })
    }

    const reset = () => {
        tasks.value = []
        firstTask.value = undefined
    }

    return {
        append,
        setFirstTask,
        tasks: readonly(tasks),
        firstTask: readonly(firstTask),
        latestTask: computed(() => tasks.value[tasks.value.length - 1]),
        tasksByTaskId,
        dropTasks,
        reset,
    }
}

export type ServerEventStore = ReturnType<typeof createServerEventStore>
